module.exports = __webpack_public_path__ + "img/logo2.0389d817.png";